<template>
  <v-card
    class="product-group-turnover mx-auto pa-2"
    outlined
  >

    <v-list-item>
      <v-list-item-content class="overflow-visible">
        <v-list-item-title class="headline mb-2">
          Doanh thu của từng nhóm sản phẩm
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <div
        v-if="turnoverReport.totalData !== 0"
    >
      <chartist
        ratio="ct-major-second"
        type="Line"
        :data="turnoverReport"
        :options="chartOptions"
        class="chart-fix"
      >
      </chartist>

      <ul class="description">
        <li v-for="(item, index) in turnoverReport.products" :key="index" class="d-inline-flex align-items-center">
          <v-avatar
            tile
            v-bind:style="{'background-color':turnoverReport.color[index % 10]}"
            size="20"
            class="mx-1"
          />
          {{item}}
        </li>
      </ul>
    </div>
    <common-no-result
      v-if="turnoverReport.totalData == 0 || Object.entries(turnoverReport).length == 0"
    />

  </v-card>
</template>

<script>
import * as ChartistTooltips from 'chartist-plugin-tooltips';
import { formatPrice } from '@/helpers/utils'


  export default {
    props: {
      turnoverReport: {
        default: () => ({})
      },
    },
    data () {
      return {
        chartOptions: {
          fullWidth: true,
          height: 300,
          chartPadding: {
            right: 50,
            left: 50
          },
          axisY: {
            offset: 80,
            labelInterpolationFnc: (value) => {
              return formatPrice(value)
            },
            scaleMinSpace: 15
          },
          plugins: [this.$chartist.plugins.tooltip(
            {
              currency: ' '
            }
          )]
        },
      }
    },
    created() {
    },
    methods: {

    },
  }
</script>

<style lang="scss">
  .product-group-turnover {
    .ct-series-a .ct-point,
    .ct-series-a .ct-line {
      stroke: teal;
    }

    .ct-series-b .ct-point,
    .ct-series-b .ct-line {
      stroke: royalblue;
    }

    .ct-series-c .ct-point,
    .ct-series-c .ct-line {
      stroke: darkgrey;
    }

    .ct-series-d .ct-point,
    .ct-series-d .ct-line {
      stroke: red;
    }

    .ct-series-e .ct-point,
    .ct-series-e .ct-line {
      stroke: yellow;
    }

    .ct-series-f .ct-point,
    .ct-series-f .ct-line {
      stroke: hotpink;
    }

    .ct-series-g .ct-point,
    .ct-series-g .ct-line {
      stroke: aqua;
    }

    .ct-series-h .ct-point,
    .ct-series-h .ct-line {
      stroke: gold;
    }

    .ct-series-i .ct-point,
    .ct-series-i .ct-line {
      stroke: blueviolet;
    }

    .ct-series-j .ct-point,
    .ct-series-j .ct-line {
      stroke: maroon;
    }

    .ct-label {
      fill: white;
    }
  }
</style>
